import {
  ICourseNode,
  INoteNode,
  ISimplifiedNode,
} from '../components/ingestion/IngestedTree'
import { NodeType } from 'shared/types/ingestion'

export function transformAllNoteContent(
  node: ICourseNode | ISimplifiedNode,
  transform: (s: string) => string,
) {
  const noteTransform = ({ data }: INoteNode) => {
    data.value = transform(data.value)
  }
  allNodesForType([node], NodeType.Note, noteTransform)
}

export function allNodesForTypePath<T extends ISimplifiedNode>(
  node: ICourseNode | ISimplifiedNode,
  typePath: NodeType[],
) {
  return typePath.reduce<ISimplifiedNode[]>(
    (acc, type) => {
      return allNodesForType(acc, type)
    },
    [node as ISimplifiedNode],
  ) as T[]
}

export function allNodesForType<T extends ISimplifiedNode>(
  nodes: (ICourseNode | ISimplifiedNode)[],
  type: NodeType,
  nodeFunc?: (n: T) => void,
) {
  let lookingIn = [...nodes]
  const found: ISimplifiedNode[] = []
  while (lookingIn.length) {
    const [next, ...rest] = lookingIn
    lookingIn = rest
    if (next.type === type) {
      found.push(next as ISimplifiedNode)
      nodeFunc?.(next as T)
    }
    if ('nodes' in next && next.nodes) {
      lookingIn.push(...next.nodes)
    }
  }
  return found
}
